import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'

const SpinLoading = () => (
  <div className="spin-container">
    <Spin style={{color: "green"}} fullscreen indicator={<LoadingOutlined spin />} size="large" />
  </div>
)

export default SpinLoading